import DateTimeP from './DateTimeP.mjs';

export default function RowCard({ promo, rowCardHtag }) {
  const dateTimeDesc = promo.shortDescription ?
    <p className="label-3">{promo.shortDescription}</p>
    :
    <DateTimeP
      startDate={promo.startDate}
      endDate={promo.endDate}
      startTime={promo.startTime}
      endTime={promo.endTime}
    />
  ;
  const detailsUrl = promo.detailsUrl ?
    <a href={promo.detailsUrl} className="btn btn-link">View Details</a> : null;
  const HeadingTag = rowCardHtag || 'h5';

  return (
    <>
      <div className="card promo-card flex-shrink-0">
        <div className="img-wrap ratio ratio-5x2 overflow-hidden card-img-top">
          <img
            src={promo.imageUrl}
            alt={promo.imageAlt}
            className=""
          />
        </div>

        <div className="card-body d-flex flex-column">
          <HeadingTag className="label-1 text-primary">{promo.name}</HeadingTag>

          {dateTimeDesc}

          <div className="mt-auto">
            {detailsUrl}
          </div>
        </div>
      </div>
    </>
  );
}
